/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddExamsSalesInvoiceDto
 */
export interface AddExamsSalesInvoiceDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddExamsSalesInvoiceDto
     */
    examIds: Array<string>;
}

/**
 * Check if a given object implements the AddExamsSalesInvoiceDto interface.
 */
export function instanceOfAddExamsSalesInvoiceDto(value: object): value is AddExamsSalesInvoiceDto {
    if (!('examIds' in value) || value['examIds'] === undefined) return false;
    return true;
}

export function AddExamsSalesInvoiceDtoFromJSON(json: any): AddExamsSalesInvoiceDto {
    return AddExamsSalesInvoiceDtoFromJSONTyped(json, false);
}

export function AddExamsSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddExamsSalesInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examIds': json['examIds'],
    };
}

export function AddExamsSalesInvoiceDtoToJSON(value?: AddExamsSalesInvoiceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examIds': value['examIds'],
    };
}

